import { requestPost } from "./common";
import { DEBUG_END_POINT_APPS } from "./config";

export type TestLikeType = "confession" | "quoteMatch";

export interface TriggerTestLikeParams {
  type: TestLikeType;
  toUserId: string;
  fromUserId?: string;
  confessionId?: string;
  locale?: "en" | "vi";
}

export default {
  triggerTestLike(params: TriggerTestLikeParams) {
    return requestPost("apps/v1/admin/notification/test-like", params, {
      baseURL: DEBUG_END_POINT_APPS,
    });
  },
};
